module.exports = __webpack_public_path__ + "static/img/会话存档.156e8f8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/会话存档.png
// module id = vq/1
// module chunks = 0